var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilemoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.015625,
    y: 0.255859,
    width: 41.4887,
    height: 41.4887,
    rx: 18.3003,
    fill: "#0D4740",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5317 15.9258C14.1961 15.9258 12.3027 17.8191 12.3027 20.1547V25.2294C12.3027 27.565 14.1961 29.4583 16.5317 29.4583H24.9895C27.2543 29.4583 29.1033 27.678 29.2133 25.4404H25.4123C23.8942 25.4404 22.6635 24.2097 22.6635 22.6916C22.6635 21.1735 23.8942 19.9428 25.4123 19.9428H29.2132C29.1028 17.7057 27.254 15.9258 24.9895 15.9258H16.5317ZM25.4123 21.2115H29.2184V24.1717H25.4123C24.5949 24.1717 23.9322 23.5091 23.9322 22.6916C23.9322 21.8742 24.5949 21.2115 25.4123 21.2115ZM15.6855 25.018C15.3352 25.018 15.0512 25.302 15.0512 25.6524C15.0512 26.0027 15.3352 26.2867 15.6855 26.2867H20.7603C21.1106 26.2867 21.3946 26.0027 21.3946 25.6524C21.3946 25.302 21.1106 25.018 20.7603 25.018H15.6855ZM25.4131 22.058C25.0628 22.058 24.7787 22.342 24.7787 22.6924C24.7787 23.0427 25.0628 23.3267 25.4131 23.3267H25.5822C25.9326 23.3267 26.2166 23.0427 26.2166 22.6924C26.2166 22.342 25.9326 22.058 25.5822 22.058H25.4131Z",
    fill: "#0D4740"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0949 15.0727C26.485 13.3884 24.7037 12.301 22.8267 12.6875L15.5523 14.1851C14.033 14.4979 12.802 15.4995 12.1582 16.8235C13.1625 15.506 14.7485 14.6557 16.533 14.6557H24.9909C25.7361 14.6557 26.4468 14.804 27.0949 15.0727Z",
    fill: "#0D4740"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilemoney);
export default __webpack_public_path__ + "static/media/mobilemoney.d8e6e3bb76b6110bb3f030cabe33d04a.svg";
export { ForwardRef as ReactComponent };